import React, { useState, useEffect, useMemo } from "react";
import classnames from "classnames";
import { Link } from "react-router-dom";
import {
    Col, Row, Card, CardBody, Nav, NavItem, NavLink,
    TabContent, TabPane, Badge, Button, Input, Spinner, Collapse, Form, Label
} from "reactstrap";
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import Paginations from 'components/Common/Pagination';

// flatpickr
import "flatpickr/dist/themes/material_blue.css";
import FlatPickr from "react-flatpickr";

const UygunGeziler = () => {
    document.title = "Uygun Geziler | Lojgo";

    // 1. ADMİN KONTROLÜ
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const isAdmin = authUser?.Users_Type_ID === 3; // 3: Admin

    const [activeTab, setActiveTab] = useState("1");
    const [isOpen, setIsOpen] = useState(false);
    const toggleFilter = () => setIsOpen(!isOpen);

    // Veri State'leri
    const [tripsData, setTripsData] = useState([]);
    const [isLoadingTrips, setIsLoadingTrips] = useState(false);
    
    // 2. SİSTEM DURUMU FİLTRE STATE'İ
    const [statusFilter, setStatusFilter] = useState('all'); // 'all', 'approved', 'pending'

    // 3. FİLTRELEME MANTIĞI
    const filteredTripsData = useMemo(() => {
        return tripsData.filter(trip => {
            if (!isAdmin) return true; // Sürücüler bu filtreyi görmez, hepsini görür
            if (statusFilter === 'approved') return trip.isAdminCheck === true;
            if (statusFilter === 'pending') return trip.isAdminCheck === false;
            return true;
        });
    }, [tripsData, statusFilter, isAdmin]);

    // 4. PAGINATION STATE'LERİ (Artık filteredTripsData üzerinden çalışıyor)
    const [currentPage, setCurrentPage] = useState(1);
    const perPageData = 8;
    const indexOfLast = currentPage * perPageData;
    const indexOfFirst = indexOfLast - perPageData;
    const currentData = useMemo(() => filteredTripsData?.slice(indexOfFirst, indexOfLast), [filteredTripsData, indexOfFirst, indexOfLast]);

    // Filtre değiştiğinde sayfayı 1'e sıfırla
    useEffect(() => {
        setCurrentPage(1);
    }, [statusFilter]);

    const toggleTab = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    // AKTİF İLANLARI ÇEKME
    useEffect(() => {
        const fetchAdverts = async () => {
            setIsLoadingTrips(true);
            try {
                // Not: Sürücüler sadece kendilerini görecekse buradaki $filter URL'sini önceki mantıktaki gibi dinamik yapabilirsin.
                const response = await fetch("https://hiflowapi.stechomeyazilim.info/Advert?$filter=Is_Active eq true&$expand=Users_Car,Advert_Location");
                const result = await response.json();

                if (result && result.value) {
                    const formattedData = result.value.map(item => {
                        const car = item.Users_Car || {};
                        const location = item.Advert_Location?.[0] || {}; 

                        return {
                            id: item.ID,
                            title: `${car.Users_Car_Brand || 'Araç'} ${car.Users_Car_Model || ''}`,
                            direction: item.Direction_Type || "Gidiş",
                            startCity: location.Start_City_Code || "Bilinmiyor",
                            endCity: location.Finish_City_Code || "Bilinmiyor",
                            startDate: item.Advert_DateTime ? new Date(item.Advert_DateTime).toLocaleDateString('tr-TR') : "-",
                            carBody: car.Car_Body_Type || "Sedan",
                            km: location.Km || "0",
                            price: item.Price || 0,
                            isAdminCheck: item.Is_AdminCheck, // <--- EKLENDİ
                            img: "https://cdn-icons-png.flaticon.com/512/3202/3202926.png" 
                        };
                    });
                    setTripsData(formattedData);
                }
            } catch (error) {
                console.error("İlanlar çekilirken hata:", error);
            } finally {
                setIsLoadingTrips(false);
            }
        };
        fetchAdverts();
    }, []);

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Partner" breadcrumbItem="Uygun Geziler" />

                    {/* FİLTRELEME ALANI */}
                    <Row className="mb-4">
                        <Col lg={12}>
                            <Card className="job-filter shadow-sm">
                                <CardBody>
                                    <Form>
                                        <Row className="g-3">
                                            <Col xxl={4} lg={4}>
                                                <Input type="text" placeholder="İlan ID veya Araç Markası Ara..." />
                                            </Col>
                                            <Col xxl={3} lg={4}>
                                                <Input type="text" placeholder="Kalkış Şehri (Örn: 34, 06)" />
                                            </Col>
                                            <Col xxl={3} lg={4}>
                                                <FlatPickr
                                                    className="form-control"
                                                    placeholder="Tarih Seçiniz"
                                                    options={{ dateFormat: "d M, Y" }}
                                                />
                                            </Col>
                                            <Col xxl={2} lg={12}>
                                                <div className="hstack gap-2">
                                                    <Button color="primary" className="w-100">
                                                        <i className="bx bx-search-alt align-middle me-1"></i> Bul
                                                    </Button>
                                                    <Button color="soft-secondary" onClick={toggleFilter} className="w-100">
                                                        <i className="bx bx-filter-alt align-middle"></i> Filtre
                                                    </Button>
                                                </div>
                                            </Col>
                                            <Collapse isOpen={isOpen}>
                                                <Row className="mt-3 g-3">
                                                    <Col md={4}>
                                                        <Label className="fw-semibold">Araç Tipi</Label>
                                                        <Input type="select" className="form-select-sm">
                                                            <option>Tümü</option>
                                                            <option>Sedan</option>
                                                            <option>SUV</option>
                                                        </Input>
                                                    </Col>
                                                    <Col md={4}>
                                                        <Label className="fw-semibold">Mesafe Aralığı</Label>
                                                        <Input type="select" className="form-select-sm">
                                                            <option>Fark etmez</option>
                                                            <option>0 - 100 km</option>
                                                            <option>100 - 500 km</option>
                                                        </Input>
                                                    </Col>
                                                </Row>
                                            </Collapse>
                                        </Row>
                                    </Form>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                    {/* TAB SİSTEMİ */}
                    <Nav tabs className="nav-tabs-custom nav-justified mb-4 bg-white rounded shadow-sm">
                        <NavItem>
                            <NavLink className={classnames({ active: activeTab === "1" })} onClick={() => toggleTab("1")} style={{ cursor: 'pointer' }}>
                                Yakındaki Geziler
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink className={classnames({ active: activeTab === "2" })} onClick={() => toggleTab("2")} style={{ cursor: 'pointer' }}>
                                Tüm Yolculuklar
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink className={classnames({ active: activeTab === "4" })} onClick={() => toggleTab("4")} style={{ cursor: 'pointer' }}>
                                Alıntılarım
                            </NavLink>
                        </NavItem>
                    </Nav>

                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="1">
                            
                            {/* 5. ADMİN DURUM FİLTRESİ */}
                            {isAdmin && (
                                <div className="d-flex align-items-center mb-4">
                                    <h6 className="me-3 mb-0 text-muted">Sistem Durumu:</h6>
                                    <Nav pills className="custom-nav-pills">
                                        <NavItem>
                                            <NavLink className={statusFilter === 'all' ? 'active bg-primary cursor-pointer' : 'cursor-pointer border me-2 text-dark'} onClick={() => setStatusFilter('all')}>
                                                Tümü
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink className={statusFilter === 'approved' ? 'active bg-success cursor-pointer' : 'cursor-pointer border me-2 text-dark'} onClick={() => setStatusFilter('approved')}>
                                                Onaylılar
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink className={statusFilter === 'pending' ? 'active bg-warning text-dark cursor-pointer' : 'cursor-pointer border text-dark'} onClick={() => setStatusFilter('pending')}>
                                                Onay Bekleyenler
                                            </NavLink>
                                        </NavItem>
                                    </Nav>
                                </div>
                            )}

                            {isLoadingTrips ? (
                                <div className="text-center py-5"><Spinner color="primary" /></div>
                            ) : (
                                <>
                                    <Row>
                                        {currentData.map((item, key) => (
                                            <Col xl={3} md={6} key={key} className="mb-4">
                                                <Card className="h-100 shadow-sm border-0">
                                                    <CardBody>
                                                        <div className="d-flex align-items-center mb-3">
                                                            <div className="avatar-sm me-3">
                                                                <span className="avatar-title rounded-circle bg-soft-primary p-2">
                                                                    <img src={item.img} alt="" className="img-fluid" />
                                                                </span>
                                                            </div>
                                                            <div className="flex-grow-1">
                                                                <h5 className="fs-16 mb-1">
                                                                    <Link to={`/job-details/${item.id}`} className="text-dark">#{item.id} - {item.title}</Link>
                                                                </h5>
                                                                <Badge color={item.direction === "Git" ? "primary" : "secondary"} pill>{item.direction}</Badge>
                                                                
                                                                {/* KART ÜZERİNDE ONAY DURUMU (Sadece Admin Görsün İstersen {isAdmin && ...} içine alabilirsin) */}
                                                                <Badge color={item.isAdminCheck ? "success" : "warning"} className="ms-2">
                                                                    {item.isAdminCheck ? "Onaylı" : "Bekliyor"}
                                                                </Badge>
                                                            </div>
                                                        </div>

                                                        <ul className="list-unstyled vstack gap-2 mb-0">
                                                            <li>
                                                                <p className="text-muted mb-0">
                                                                    <i className="mdi mdi-map-marker-distance text-primary me-2"></i>
                                                                    <strong>{item.startCity}</strong> → <strong>{item.endCity}</strong>
                                                                </p>
                                                            </li>
                                                            <li>
                                                                <p className="text-muted mb-0">
                                                                    <i className="mdi mdi-calendar-check text-primary me-2"></i>
                                                                    {item.startDate}
                                                                </p>
                                                            </li>
                                                            <li>
                                                                <p className="text-muted mb-0">
                                                                    <i className="mdi mdi-car-info text-primary me-2"></i>
                                                                    {item.carBody} | {item.km} KM
                                                                </p>
                                                            </li>
                                                        </ul>

                                                        <div className="mt-4 pt-3 border-top d-flex justify-content-between align-items-center">
                                                            <h5 className="text-primary mb-0">€{item.price} <small className="text-muted fs-12">HİZMET</small></h5>
                                                            <Link to={`/job-details/${item.id}`} className="btn btn-soft-primary btn-sm px-3">
                                                                Erişim <i className="mdi mdi-arrow-right ms-1"></i>
                                                            </Link>
                                                        </div>
                                                    </CardBody>
                                                </Card>
                                            </Col>
                                        ))}
                                        
                                        {/* Eğer filtrelenmiş veri boşsa uyarı göster */}
                                        {currentData.length === 0 && (
                                            <Col xs={12}>
                                                <div className="text-center text-muted py-5">
                                                    Bu filtreye uygun ilan bulunamadı.
                                                </div>
                                            </Col>
                                        )}
                                    </Row>
                                    
                                    {/* Pagination'a tripsData yerine filteredTripsData veriyoruz */}
                                    {filteredTripsData.length > 0 && (
                                        <Paginations
                                            perPageData={perPageData}
                                            data={filteredTripsData}
                                            currentPage={currentPage}
                                            setCurrentPage={setCurrentPage}
                                            isShowingPageLength={true}
                                            paginationClass="pagination justify-content-center pagination-rounded mt-4"
                                        />
                                    )}
                                </>
                            )}
                        </TabPane>

                        <TabPane tabId="2">
                             <Card><CardBody>Tüm yolculuklar (Benzer mantıkla buraya da kartları basabilirsin)</CardBody></Card>
                        </TabPane>

                        <TabPane tabId="4">
                            <Card><CardBody>Teklifleriniz burada listelenir...</CardBody></Card>
                        </TabPane>
                    </TabContent>
                </div>
            </div>
        </React.Fragment>
    );
};

export default UygunGeziler;